import { Injectable, inject } from '@angular/core';
import { ClubHubDataService } from './clubhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class ClubHubESISService {
  private readonly clubHubDataService = inject(ClubHubDataService);

  private lendersWithConfiguredEsisInformation: string[] = [];

  public getEsisConfiguredLenders(lenderTypeId: number) {
    this.clubHubDataService
      .get<string[]>(`esisInformation/configured/${lenderTypeId}`)
      .subscribe(lenders => (this.lendersWithConfiguredEsisInformation = lenders));
  }

  public isLenderEsisConfigured(lenderName: string): boolean {
    return this.lendersWithConfiguredEsisInformation.includes(lenderName);
  }
}
